import { React, useState, useEffect } from 'react'
import { HashLink as Link } from 'react-router-hash-link';
import { motion, useAnimation } from "framer-motion";
import { Squircle } from "@squircle-js/react";
import { useParams, } from "react-router-dom";
import joi from 'joi';
import { Helmet } from 'react-helmet'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faEnvelope, faEnvelopeOpenText, faPersonChalkboard, faTrash, faChevronRight, faDownload, faSearch, faPhone, faMobile, faMapMarkerAlt, faCamera, faCalendarCheck, faChevronDown, faChevronUp, faPaperPlane } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import DownloadButton from '../../../components/DownloadButton/DownloadButton.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'

import { lP, oP, sT, boxvar1, boxvar2, boxvar3, boxvar2_1, boxvar2_2, boxvar2_3, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, capFirstChar, convertToCSV, downloadCSV, getAge, downloadPdf } from '../../../main.js'

import '../../../main.css'
import './ManageEventAttendees.css'
import './MManageEventAttendees.css'

import logo_mainbyton from '../../../assets/pictures/logos/4Helferzeit-Logo2x.webp'
import m_logo_mainbyton from '../../../assets/pictures/logos/1Helferzeit-Logo2x.webp'
import img_not_found from '../../../assets/pictures/imgnotfound.webp'

import Cookies from 'universal-cookie'


export default function ManageEventAttendees() {


    var [resError, setResError] = useState("")

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    var [eventData, setEventData] = useState([])
    var [loadedEventData, setLoadedEventData] = useState(0)
    var [eventAttendees, setEventAttendees] = useState([])
    var [loadedEventAttendees, setLoadedEventAttendees] = useState(0)


    var [foundUsers, setFoundUsers] = useState([]);
    var [userQuery, setUserQuery] = useState('');

    //TODO check permission or is manager


    const { eventid } = useParams();



    useEffect(() => {
        getEventData()
        getEventAttendees()

        const listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                // event.preventDefault()
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }


    }, [])

    function getEventData() {

        try {
            setLoadedEventData(0)


            fetch(URL_MAINAPI + "/event/" + eventid + "?ignoreinactive=1", {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {

                    setEventData(res.data)
                    setLoadedEventData(1)

                } else {
                    setEventData([])
                    setLoadedEventData(0)

                }
            })
            )

        } catch (err) {
            setEventData([])
            setLoadedEventData(0)

        }

    }


    function getEventAttendees() {

        try {
            setLoadedEventAttendees(0)


            fetch(URL_MAINAPI + "/event/attendees/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {

                    setEventAttendees(res.data)
                    setFoundUsers(res.data)
                    setLoadedEventAttendees(1)

                } else {
                    setEventAttendees([])
                    setFoundUsers([])

                    setLoadedEventAttendees(0)

                }
            })
            )

        } catch (err) {
            setEventAttendees([])
            setFoundUsers([])
            setLoadedEventAttendees(0)

        }

    }




    function exportUserTable() {
        const csvContent = convertToCSV(eventAttendees);
        const timestamp = formatDateWithTime(new Date()).replace(/[-:. ]/g, '-')
        const filename = 'export_teilnehmerliste_' + ((eventData?.shortname) ? eventData.shortname.replace(/[-:. ]/g, '-') : 'event') + '_Stand-' + timestamp + '.csv';
        downloadCSV(csvContent, filename);

    }

    var [isOpen, setIsOpen] = useState(0)
    function toggleDetails() {
        // Select all <details> elements in the document
        const detailsElements = document.querySelectorAll('details');
        detailsElements.forEach(detail => {
            detail.open = !isOpen; // Sets the open property to true, expanding the element
            setIsOpen(!isOpen);
        });
    };



    function searchUsers(users, query) {

        if (query.length <= 2) {
            setFoundUsers(users)
        } else {
            setFoundUsers([])
        }
        const lowerQuery = query.toLowerCase();

        var foundusers = users.filter(user => {
            const matchesUserFields = Object.values(user).some(value =>
                typeof value === 'string' && value.toLowerCase().includes(lowerQuery)
            );
            const matchesCompanions = Array.isArray(user.companions) && user.companions.some(companion =>
                [companion.firstname, companion.lastname]
                    .filter(Boolean)
                    .some(name => String(name).toLowerCase().includes(lowerQuery))
            );
            return matchesUserFields || matchesCompanions;
        });
        setIsFilteredByChannel(0)
        console.log("Found users", foundusers);
        setFoundUsers(foundusers);
    }

    var [isFilteredByChannel, setIsFilteredByChannel] = useState(0)

    useEffect(() => {

        // function filterUserByChannel(users) {

        if (isFilteredByChannel == 1) {
            var foundusers = eventAttendees.filter(user => user.additionalInfo.preferred_channel == 2);

            setFoundUsers(foundusers);
        } else {
            setFoundUsers(eventAttendees)
        }

    }, [isFilteredByChannel])

    function getPdfSchedule(user) {
        return downloadPdf(
            "/mailing/getscheduleplanpdf/" + eventid + "/" + user._id,
            'Dienstplan_' + eventData.shortname + '_' + user.firstname + '_' + user.lastname + '.pdf',
            cur_authtoken
        )
    }

    function removeAttendee(eventid, userid) {
        if (!window.confirm("User wirklich löschen? Er wird unwiderruflich auch aus den Dienstplänen entfernt (ggf. prüfen)")) return

        var reqbody = {
            "userid": userid
        }

        try {
            fetch(URL_MAINAPI + "/user/manage-unattend/" + eventid, {
                method: "DELETE",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    window.location.reload()
                } else {

                }
            })
            )

        } catch (err) {


        }
    }


    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Helferverwaltung</title>
                <meta property="og:title" content="Helferverwaltung" />
                <meta property="og:description" content="Verwalte die Helfer für deine Veranstaltung" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    <a href='/profil'>Profil</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    {eventData.orgid ? <><a href={'/manage/org/' + eventData.orgid}>{eventData.organization ? eventData.organization.name : 'Organisation'}</a><FontAwesomeIcon icon={faChevronRight} /></> : null}
                    <a href={'/manage/event/' + eventid}>{eventData.name || 'Event'}</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <span>Helferverwaltung</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    🛠️ Helfer verwalten
                </motion.h1>
                {loadedEventData ? <p className='section-sub'>für <a href={"/manage/event/" + eventid}>{eventData.name}</a></p> : <Skeleton width="240px" />}

                {(eventData.active != 1) ? (
                    <div className='banner-info' style={{ background: 'var(--warn-soft)', color: 'var(--warn)', marginBottom: '16px' }}>
                        ⚠️ Event ist inaktiv und für andere nicht aufrufbar!
                    </div>
                ) : null}

                {(loadedEventAttendees) ? (
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card' style={{ padding: '24px 26px', marginBottom: '20px' }}>
                            <div className='attendee-toolbar'>
                                <div className="field" style={{ flex: '1 1 260px', maxWidth: '400px', marginBottom: 0 }}>
                                    <input
                                        placeholder='Teilnehmer suchen 🔎'
                                        type="search"
                                        onChange={(e) => { searchUsers(eventAttendees, e.target.value); setUserQuery(e.target.value); }}
                                        value={userQuery}
                                        style={{ padding: '12px 16px', border: '1.5px solid var(--border-strong)', borderRadius: 'var(--radius-md)', fontSize: '16px' }}
                                    />
                                </div>

                                <div className='attendee-toolbar-actions'>
                                    <button
                                        type='button'
                                        className={'toggle-chip' + (isOpen ? ' toggle-chip-active' : '')}
                                        aria-pressed={isOpen ? 'true' : 'false'}
                                        title={(isOpen) ? "Alle Details zuklappen" : "Alle Details aufklappen"}
                                        onClick={() => toggleDetails()}
                                    >
                                        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                                        <span>{(isOpen) ? "Zuklappen" : "Aufklappen"}</span>
                                    </button>
                                    <button
                                        type='button'
                                        className={'toggle-chip' + (isFilteredByChannel ? ' toggle-chip-active' : '')}
                                        aria-pressed={isFilteredByChannel ? 'true' : 'false'}
                                        title={(isFilteredByChannel) ? "Filter entfernen und alle Helfer zeigen" : "Nur Helfer mit Postkommunikation zeigen"}
                                        onClick={() => setIsFilteredByChannel(!isFilteredByChannel)}
                                    >
                                        <FontAwesomeIcon icon={faEnvelopeOpenText} />
                                        <span>{(!isFilteredByChannel) ? "Nur Post" : "Alle"}</span>
                                    </button>
                                    <CTAButton variant="primary" size="sm" hideArrow={false} title="CSV herunterladen" onclick={() => exportUserTable()} />
                                </div>
                            </div>

                            {(foundUsers.length > 0 && userQuery.length > 0) ? (
                                <p style={{ color: 'var(--text-secondary)', fontSize: '15px' }}>Suchergebnisse: ({foundUsers.length} Treffer)</p>
                            ) : (userQuery.length > 0) ? (
                                <p style={{ color: 'var(--text-secondary)', fontSize: '15px' }}>suchen...</p>
                            ) : null}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            {(foundUsers.length > 0) ? foundUsers.map(function (attendee) {
                                attendee.age = getAge(attendee.birthday)
                                const companions = Array.isArray(attendee.companions) ? attendee.companions : []
                                const companionLabel = companions.length > 0 ? ` (+${companions.length})` : ''

                                return (
                                    <details key={attendee._id} className='card attendee-card'>
                                        <summary style={{ cursor: "pointer", padding: '16px 20px' }}>
                                            <b>{attendee.firstname} {attendee.lastname}{companionLabel} ({attendee.age})</b>
                                            {attendee.agreements.photos_agreed ? "" : <span className='badge badge-error' title="Keine Fotos gewünscht"><FontAwesomeIcon icon={faCamera} /> Keine Fotos</span>}
                                            {(attendee.additionalInfo.preferred_channel == 2) ? <span className='badge badge-info' title="Postkommunikation"><FontAwesomeIcon icon={faEnvelopeOpenText} /> Post</span> : ""}
                                        </summary>
                                        <div className='attendee-detail' style={{ padding: '0 20px 20px' }}>
                                            <div className="kv-list">
                                                <div className="kv"><FontAwesomeIcon icon={faEnvelope} /><b>Mail</b> <a href={"mailto:" + attendee.contact.email}>{attendee.contact.email}</a></div>
                                                <div className="kv"><FontAwesomeIcon icon={faPhone} /><b>Tel</b> {attendee.contact.tel}</div>
                                                <div className="kv"><FontAwesomeIcon icon={faMobile} /><b>Mobil</b> {attendee.contact.mobile}</div>
                                                <div className="kv"><FontAwesomeIcon icon={faMapMarkerAlt} /><b>Anschrift</b> {attendee.address.street + " " + attendee.address.nr + ", " + attendee.address.zipcode + " " + attendee.address.city + " - " + attendee.address.country + ((attendee.address.addon != "") ? " (" + attendee.address.addon + ")" : "")}</div>
                                            </div>
                                            <div className="kv-list" style={{ marginTop: '12px' }}>
                                                <div className="kv"><FontAwesomeIcon icon={faCamera} /><b>Fotos gewollt?</b> {attendee.agreements.photos_agreed ? "Ja" : "Nein"}</div>
                                                <div className="kv"><FontAwesomeIcon icon={faPaperPlane} /><b>Kommunikation</b> {(attendee.additionalInfo.preferred_channel == 2) ? "Mail und Post" : "Mail"}</div>
                                                <div className="kv"><FontAwesomeIcon icon={faCalendarCheck} /><b>Wunschdienste</b> {attendee.isScheduleRegistered ? "Ja" : "Nein"}</div>
                                            </div>
                                            {(companions.length > 0) ? (
                                                <div style={{ marginTop: '12px' }}>
                                                    <b>Mitgebracht ({companions.length}):</b>
                                                    {companions.map(function (companion, index) {
                                                        return (
                                                            <div key={attendee._id + '_companion_' + index} style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                                                                ↳ {companion.firstname} {companion.lastname}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            ) : null}
                                            {(attendee.additionalInfo.qualifications) ? <p style={{ marginTop: '12px', fontSize: '14px', color: 'var(--text-secondary)' }}><b>Zusatzinfos:</b> {attendee.additionalInfo.qualifications}</p> : null}
                                            {(attendee.scheduleRemark) ? <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}><b>Bemerkung (Dienstplan):</b> {attendee.scheduleRemark}</p> : null}

                                            <div style={{ display: 'flex', gap: '10px', marginTop: '16px', flexWrap: 'wrap' }}>
                                                <button className='btn btn-quiet btn-sm' style={{ color: 'var(--error)' }} onClick={() => removeAttendee(eventid, attendee._id)}><FontAwesomeIcon icon={faTrash} /> Entfernen</button>
                                                <DownloadButton size="sm" title="Dienstplan herunterladen" onDownload={() => getPdfSchedule(attendee)} />
                                            </div>
                                        </div>
                                    </details>
                                )
                            }) : null}
                        </div>
                    </motion.div>
                ) : (
                    <Skeleton variant="card" />
                )}

            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
